import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useWbpModel } from "../wbpModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { IWbpDetail } from "../wbpTypes";
import { formatNum } from "@/utils/utils";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys
    } = useWbpModel();

    const { getTreeNodeName, getTreeNodeValue } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IWbpDetail> = [
        {
            title: '序号',
            width: 45,
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '信用证号',
            width: 160,
            dataIndex: 'code',
            fixed: "left",
            render: t => t === "listTotalAmount" ? "" : t
        }, {
            title: '状态',
            width: 100,
            dataIndex: 'status',
            render: text => getTreeNodeName(text)
        }, {
            title: '客户名称',
            width: 160,
            dataIndex: 'customerName',
            ellipsis: true,
        }, {
            title: '价格条款',
            width: 160,
            dataIndex: 'customerName',
            ellipsis: true,
        }, {
            title: '装货港',
            width: 160,
            dataIndex: 'customerName',
            ellipsis: true,
        }, {
            title: '卸货港',
            width: 160,
            dataIndex: 'customerName',
            ellipsis: true,
        }, {
            title: '出运状态',
            width: 80,
            dataIndex: "currencyName"
        }, {
            title: '提单号',
            width: 200,
            dataIndex: "shipment",
        }, {
            title: '提单日期',
            width: 180,
            dataIndex: 'discharge',
            render: text => getTreeNodeName(text)
        }, {
            title: 'EDA',
            width: 100,
            dataIndex: 'clause',
            render: text => getTreeNodeName(text)
        }, {
            title: 'ETD',
            width: 100,
            dataIndex: 'typeNum',
        }, {
            title: '托运',
            width: 100,
            dataIndex: 'createUser',
        }, {
            title: '商检',
            width: 100,
            dataIndex: 'createUser',
        }, {
            title: '订舱',
            width: 100,
            dataIndex: 'createUser',
        }, {
            title: '装柜',
            width: 100,
            dataIndex: 'createUser',
        }, {
            title: '报关放行',
            width: 100,
            dataIndex: 'createUser',
        }, {
            title: '装船',
            width: 100,
            dataIndex: 'createUser',
        }, {
            title: '提单',
            width: 100,
            dataIndex: 'createUser',
        }, {
            title: '交单/寄单',
            width: 100,
            dataIndex: 'createUser',
        }, {
            title: '入库',
            width: 180,
            dataIndex: 'createTime',
        }
    ];


    //点击行选高亮
    const onRow = (code: string) => {
        let findIndex = selectedRowKeys.indexOf(code);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(code);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };


    return (
        <Table
            rowKey={record => record.code}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.code).filter(item => item !== "listTotalAmount");
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.code),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.code),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.code]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
